export default __webpack_public_path__ + "static/superbetter-impact-bg-1fd1806452fcc8e3f7f75cc756fc5965.webp";